<template lang="pug">
#timeline-historico-monitoramento
    el-timeline(v-if='dados.length')
        el-timeline-item(
            v-for='(dado, index) in dados',
            :key='index',
            :color='dado.color',
            size='large'
        )
            div(
                :class='[dado.identificouNovaRestricao ? "time-line-box alerta" : "time-line-box"]'
            )
                .time-line-box--texto
                    p.titulo {{ dado.titulo }}
                    p.subtitulo {{ dado.descricao }}
                .time-line-box--acoes(
                    v-if='dado.tipoMonitoramento === TipoMonitoramento.SOCIOAMBIENTAL'
                )
                    .buttons
                        el-button.mdi.mdi-file-pdf-box.mdi-36px(
                            v-if='(dado.identificouNovaRestricao || dado.cadastro) && !dado.loading',
                            @click='gerarPdf(dado)'
                        )
                        .mdi.mdi-loading.mdi-36px.mdi-spin.loading-pdf(
                            v-if='dado.loading'
                        )

                        el-button.button-arrow(
                            icon='el-icon-arrow-right',
                            @click='linkHistorico(dado)'
                        )
    el-empty(v-else, description='Nenhum resultado encontrado')

    ModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento(
        :territorio='territorio',
        :show='showModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento',
        @close='closeModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento'
    )
</template>

<script>
import ModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento from '@/components/monitoramento/ModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento';
import TipoMonitoramento from '@/constants/TipoMonitoramento';
import { retryOperation } from '@/utils/retry-operation';
import { mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';

import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';

export default {
    name: 'TimelineHistoricoMonitoramento',
    components: {
        ModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento
    },
    props: {
        dados: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    data() {
        return {
            TipoMonitoramento,
            showModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento: false,
            territorio: {}
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        async linkHistorico(dado) {
            if (dado.tipoMonitoramento === TipoMonitoramento.SOCIOAMBIENTAL) {
                await this.buscarDiagnosticoTerritorio(
                    dado.diagnosticoSocioambientalId,
                    dado.territorio
                );
            }
        },
        async gerarPdf(dado) {
            if (!this.usuarioLogado) {
                this.$notify.error({
                    message: 'Usuário deslogado!'
                });
                return;
            }

            try {
                await connect();
            } catch {
                this.$notify.error({
                    message:
                        'Não foi possível se conectar na api para realizar o download do pdf!'
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                    response => {
                        if (response) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = 'diagnosticos-socioambientais.pdf';

                            const currentDate = new Date();
                            const formattedDate = `${currentDate.getFullYear()}${String(
                                currentDate.getMonth() + 1
                            ).padStart(2, '0')}${String(
                                currentDate.getDate()
                            ).padStart(2, '0')}`;
                            const formattedTime = `${String(
                                currentDate.getHours()
                            ).padStart(2, '0')}${String(
                                currentDate.getMinutes()
                            ).padStart(2, '0')}${String(
                                currentDate.getSeconds()
                            ).padStart(2, '0')}`;

                            const newFileName = fileName.replace(
                                '.pdf',
                                `-${formattedDate}-${formattedTime}.pdf`
                            );

                            link.href = linkSource;
                            link.download = newFileName;
                            link.click();
                            link.remove();
                            this.$notify.success({
                                message: 'Download realizado com sucesso!'
                            });
                        } else {
                            this.$notify.error({
                                message: 'Não foi possível exportar o pdf!'
                            });
                        }
                        dado.loading = false;
                        disconnect();
                    }
                );

                dado.loading = true;

                const params = {
                    idTerritorio: dado.territorio.id,
                    idDiagnostico: dado.diagnosticoSocioambientalId,
                    tipoDocumento: 'TERRITORIO',
                    camadas: null,
                    buffer: null
                };

                const dados = [];
                dados.push(params);

                await retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    dados,
                    5000,
                    10
                );
            } catch (error) {
                dado.loading = false;
                this.$notify.error({
                    message: 'Não foi possível exportar o pdf!'
                });
                disconnect();
            }
        },

        async buscarDiagnosticoTerritorio(idDiagnostico, territorio) {
            try {
                const { data } =
                    await MonitoramentoSocioambientalService.consultaDiagnosticoPorIdETerritorioId(
                        idDiagnostico,
                        territorio.id
                    );

                this.territorio = {
                    ...territorio,
                    dataDiagnostico:
                        data.diagnosticoSocioAmbientalTerritorio
                            .dataDiagnosticoFormatado,
                    informacoes_gerais:
                        data.diagnosticoSocioAmbientalTerritorio
                            .informacoes_gerais,
                    idDiagnosticoSocioambiental:
                        data.diagnosticoSocioAmbientalTerritorio
                            .idDiagnosticoSocioambiental,

                    diagnosticos:
                        data.diagnosticoSocioAmbientalTerritorio.responseDiagnosticos.map(
                            r => ({
                                camada: { ...r.camada, opacidade: 100 },
                                nivelAlerta: r.nivelAlerta,
                                status: r.status,
                                resultados: r.resultados.map(r => r.properties),
                                geometria: r.resultados.map(
                                    r => r.geometria || r.geometry
                                )
                            })
                        ),
                    representantes:
                        data.diagnosticoSocioAmbientalTerritorio.diagnosticoPorRepresentante.map(
                            representante => ({
                                documento: representante.documento,
                                nomeRepresentante:
                                    representante.nomeRepresentante,

                                diagnostico: representante.diagnostico.map(
                                    r => ({
                                        camada: { ...r.camada, opacidade: 100 },
                                        nivelAlerta: r.nivelAlerta,
                                        status: r.status,
                                        resultados: r.resultados
                                    })
                                )
                            })
                        ),
                    dadosCar:
                        data.diagnosticoSocioAmbientalTerritorio.responseDiagnosticoCar.map(
                            r => ({
                                imovel: r.imovel,
                                diagnosticos: r.diagnosticos.map(d => ({
                                    camada: { ...d.camada, opacidade: 100 },
                                    nivelAlerta: d.nivelAlerta,
                                    status: r.status,
                                    resultados: d.resultados
                                }))
                            })
                        )
                };
            } catch (error) {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao buscar os dados do diagnostico socioambiental dos território.'
                });
            } finally {
                this.alterarNomeCamada();
            }
        },

        alterarNomeCamada() {
            try {
                this.territorio.diagnosticos.sort((a, b) => {
                    return a.camada.nome.localeCompare(b.camada.nome);
                });

                Object.keys(this.territorio.diagnosticos).forEach(item => {
                    if (
                        this.territorio.diagnosticos[item].camada.nome ===
                        'Áreas embargadas'
                    ) {
                        this.territorio.diagnosticos[item].camada.nome =
                            'Áreas embargadas (IBAMA)';
                    } else if (
                        this.territorio.diagnosticos[item].camada.nome ===
                        'Monitoramento Desmatamento'
                    ) {
                        this.territorio.diagnosticos[item].camada.nome =
                            'Desmatamento Lyra';
                    }
                });

                Object.keys(this.territorio.representantes).forEach(
                    itemRepresentante => {
                        Object.keys(
                            this.territorio.representantes[itemRepresentante]
                                .diagnostico
                        ).forEach(i => {
                            if (
                                this.territorio.representantes[
                                    itemRepresentante
                                ].diagnostico[i].camada.nome ===
                                'Áreas embargadas'
                            ) {
                                this.territorio.representantes[
                                    itemRepresentante
                                ].diagnostico[i].camada.nome =
                                    'Áreas embargadas (IBAMA)';
                            } else if (
                                this.territorio.representantes[
                                    itemRepresentante
                                ].diagnostico[i].camada.nome ===
                                'Monitoramento Desmatamento'
                            ) {
                                this.territorio.representantes[
                                    itemRepresentante
                                ].diagnostico[i].camada.nome =
                                    'Desmatamento Lyra';
                            }
                        });
                    }
                );

                this.territorio.dadosCar.forEach(dadoCar => {
                    dadoCar.diagnosticos.forEach(diagnostico => {
                        if (diagnostico.camada.nome === 'Áreas embargadas') {
                            diagnostico.camada.nome =
                                'Áreas Embargadas (IBAMA)';
                        } else if (
                            diagnostico.camada.nome ===
                            'Monitoramento Desmatamento'
                        ) {
                            diagnostico.camada.nome = 'Desmatamento Lyra';
                        }
                    });
                });
            } finally {
                this.showModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento = true;
            }
        },
        closeModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento() {
            this.showModalVisualizarDiagnosticoSocioambientalTerritorioMonitoramento = false;
        }
    }
};
</script>

<style lang="scss">
#timeline-historico-monitoramento {
    margin-top: 25px;
    padding: 0 14px;
    .el-timeline {
        padding-left: 2px !important;
        .el-timeline-item {
            padding-bottom: 0px;
            .el-timeline-item__node {
                top: 25px;
            }
            .el-timeline-item__wrapper {
                .time-line-box {
                    background: var(--white);
                    border: 1px solid var(--default-background-color);
                    display: flex;
                    justify-content: space-between;

                    .time-line-box--texto {
                        padding: 10px 7px;
                        p {
                            &.titulo {
                                margin: 0;
                                padding-top: 0;
                                font-weight: 600;
                                color: #3b3b3b;
                            }
                            &.subtitulo {
                                margin: 0;
                                color: var(--primary);
                                font-size: 12px;
                            }
                        }
                    }
                    .time-line-box--acoes {
                        padding-left: 5px;
                        background-color: var(--white);
                        align-items: center;
                        color: (--black);
                        .buttons {
                            display: flex;
                            height: 100%;

                            .button-arrow {
                                padding: 12px 5px;
                                margin-left: 5px;
                            }
                            .el-button {
                                background: #f3f3f3;
                                border-radius: 0px;
                                border-color: transparent;
                            }
                            .el-button.is-disabled {
                                color: #3b3b3b;
                            }
                            .el-button:not(.is-disabled):hover {
                                background: rgba(248, 131, 66, 0.4);
                            }

                            .loading-pdf {
                                background: #f3f3f3;
                                padding: 7px 20px;
                            }
                        }
                    }
                }
                .alerta {
                    background: var(--background-danger);
                }
            }
            .el-timeline-item__tail {
                border-left: 2px solid #d1cece !important;
                top: 35px;
            }
        }
    }
}
</style>
